<template>
  <v-dialog
    v-model="open"
    width="600"
  >
    <v-card>
      <v-card-title
        class="headline light-blue lighten-1"
        primary-title
      >
        <v-row no-gutters>
          <v-col>{{title}}</v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="card-text-height">
        <div v-if="list">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="head in headers"><b>{{head}}</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.label">
                    <td>{{ item.label }}</td>
                    <td>{{ item.data[0] }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions fixed>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dismiss()">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: "showList",
    props: ['list', 'title', 'headers'],
    data() {
      return {
        toggle: true,
        open: false,
        formatted: null
      }
    },
    methods: {
      openModal(){
        this.open = true;
        // this.$ga.event('Profile details', 'open', this.getLabel());
        this.$gtag.event('open', {
          event_category: 'Profile details',
          event_label: this.getLabel()
        });
      },
      dismiss() {
        this.open = false;
        // this.$ga.event('Profile details', 'cancel', this.getLabel());
        this.$gtag.event('cancel', {
          event_category: 'Profile details',
          event_label: this.getLabel()
        });
      },
      getLabel(){
        return this.title ? `full list ${this.title}` : 'full list';
      }

    }
  }
</script>

<style scoped>
  .card-text-height {
    max-height: 350px;
    overflow-y: scroll
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Profiles/showList.vue